<div>
  {{ title }}<span class="text-right"><i class="fa fa-sort"></i></span>
</div>
